function runAt(selector, callback) {
  function check() {
    const el = document.querySelector(selector);
    if (el) {
      callback(el);
    } else {
      requestAnimationFrame(check);
    }
  }

  requestAnimationFrame(check);
}

function convertToLocalCurrency(amount) {
  const currency =
    Shopify.currency?.active || "USD";

  const symbolMap = {
    USD: "$",
    INR: "₹",
    EUR: "€",
    GBP: "£",
    AUD: "$",
    CAD: "$"
  };

  const symbol =
    symbolMap[currency] || currency;

  return `${symbol}${parseFloat(amount).toFixed(2)}`;
}

const globalFunction = () => {

  // const variant = 'bl-variant-2';
  const variant = window.echoVariant;

  const currency =
    window.Shopify?.currency?.active || 'USD';

  /*
  -----------------------------------
  BASE THRESHOLDS
  -----------------------------------
  */

  const SHIPPING_THRESHOLDS = {
    AUD: 69,
    USD: 50,
    CAD: 69,
    GBP: 45,
    EUR: 45
  };

  /*
  -----------------------------------
  A/B VARIANT OVERRIDE (FIXED)
  -----------------------------------
  */

  if (currency === "USD") {

    if (variant === "bl-variant-2") {
      SHIPPING_THRESHOLDS.USD = 75;
    }

    if (variant === "bl-variant-1") {
      SHIPPING_THRESHOLDS.USD = 50;
    }

  }

  /*
  -----------------------------------
  VALIDATION
  -----------------------------------
  */

  if (!SHIPPING_THRESHOLDS[currency]) return;

  const threshold =
    SHIPPING_THRESHOLDS[currency];

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      const cartTotal =
        cart.total_price / 100;

      const remaining =
        Math.max(threshold - cartTotal, 0);

      const progress =
        Math.min((cartTotal / threshold) * 100, 100);

      const target =
        document.querySelector(
          '#UpcartPopup .upcart-freeshipping_bar'
        );

      if (!target) return;

      target.innerHTML = `
        <div class="ig-shipping-bar ${remaining <= 0 ? 'is-unlocked' : ''}">

          <div class="ig-shipping-bar__text">
            ${
              remaining > 0
                ? `You're ${convertToLocalCurrency(remaining)} away from free shipping!`
                : `You have unlocked free shipping! 🎉`
            }
          </div>

          <div class="ig-shipping-bar__progress">
            <div 
              class="ig-shipping-bar__fill"
              style="width:${progress}%"
            ></div>
          </div>

          <div class="ig-shipping-bar__footer">
            <span>${convertToLocalCurrency(0)}</span>
            <span>${convertToLocalCurrency(threshold)}</span>
          </div>

        </div>
      `;

    });

};

window.addEventListener("load", () => {
  runAt(
    'body #UpcartPopup .upcart-freeshipping_bar',
    globalFunction
);
});

document.addEventListener('cart:updated', () => {
  globalFunction();
});

(function () {

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {

    const response =
      await originalFetch.apply(this, args);

    const url = args[0];

    if (
      typeof url === 'string' &&
      (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update')
      )
    ) {

      setTimeout(() => {
        globalFunction();
      }, 300);

    }

    return response;

  };

})();